// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"7d206541","195":"bc60c383","283":"410e4aa9","711":"fd646970"}[chunkId] + ".chunk.css";
};